var exports = {
  "c": "ActivityPeople.module__people___Z1ZzLW",
  "U": "ActivityPeople.module__count___Z1ZzLW",
};

module.exports = exports;
